export const Checkbox = ({ attributes, title }: any) => {
  return (
    <label htmlFor={title} className="text-sm">
      <input id={title} type="checkbox" {...attributes} className="mr-2 disabled:opacity-40" />
      {title}?
    </label>
  );
};
